"use client";

import {
	CategoryCtaButton,
	type CategoryCtaButtonProps,
} from "~/app/[lang]/(default)/category/[id]/MainCategoryCta";
import { useCommand } from "~/app/[lang]/command/Context";

export function CategoryCtaImportButton(props: CategoryCtaButtonProps) {
	const { importProductsCallback } = useCommand();

	return <CategoryCtaButton {...props} onClick={importProductsCallback} />;
}
